import { render, staticRenderFns } from "./proposal-list.vue?vue&type=template&id=525c668a"
import script from "./proposal-list.vue?vue&type=script&lang=js"
export * from "./proposal-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports